import Card from '~/components/Card';
import DescriptionList, {
  DescriptionListItem,
} from '~/components/DescriptionList';
import PaymentCardInput from '~/components/PaymentCardInput';

export default function PaymentSummary<Amount extends { display: string }>({
  amount,
  headline = 'Payment Summary',
  label,
}: {
  amount: Amount;
  headline?: string;
  label: string;
}) {
  return (
    <Card headline={headline}>
      <div className="flex flex-col divide-y divide-outline *:py-4 *:first:pt-0 *:last:pb-0">
        <DescriptionList>
          <DescriptionListItem
            variant="lg"
            label={label}
            value={amount.display}
          />
        </DescriptionList>

        <PaymentCardInput />
      </div>
    </Card>
  );
}
